<template lang="pug">
    div
        div(v-if="isLoading")
            Loader
        div(v-else)
            //b-form.w-100(@submit.prevent="editFamily")
                table.table.table-sm
                    thead
                        th Name
                        th Gender
                        th DoB
                        th Relationship
                        th Citizenship
                        th Occupation/Income
                        th School/Level/Year
                        th
                    tr(v-for="(familyMember, index) in client.new_FamilyMember_Client_new_Client")
                        td 
                            b-form-input(v-model="familyMember.new_name" type="text" required)
                        td
                            b-form-select(v-model="familyMember.new_gender" required)
                                b-form-select-option(value="")
                                b-form-select-option(value="100000000") Male
                                b-form-select-option(value="100000001") Female
                        td
                            b-form-input(v-model="familyMember.new_birthdate" type="date" required)
                        td
                            b-form-input(v-model="familyMember.new_relationship" type="text" required)
                        td
                            b-form-select(v-model="familyMember.new_citizenship" required)
                                b-form-select-option(value="")
                                b-form-select-option(value="100000000") Singapore
                                b-form-select-option(value="100000001") Singapore PR
                                b-form-select-option(value="100000002") Others
                        td
                            div.d-flex
                                b-form-input.mr-1(v-model="familyMember.new_occupation" type="text" placeholder="Occupation")
                                b-form-input(v-model.number="familyMember.new_income" type="number" min="0" placeholder="Income")
                        td
                            div.d-flex
                                b-form-input(v-model="familyMember.new_school" type="text" placeholder="School")
                                b-form-select.mx-1(v-model="familyMember.new_schoollevel")
                                    b-form-select-option(:value="null")
                                    b-form-select-option(value="100000000") Primary
                                    b-form-select-option(value="100000001") Secondary
                                    b-form-select-option(value="100000002") Polytechnic
                                    b-form-select-option(value="100000003") University
                                b-form-input(v-model.number="familyMember.new_schoolyear" type="number" min="0" placeholder="Year")
                        td
                            b-button(@click="removeItem(index)")
                                b-icon(icon="trash")
                b-button(@click="addItem()") + Add Family Member
                hr
                b-button(type="submit" :disabled="isSubmitting") {{ isSubmitting ? 'Saving...' : 'Save'}}


            b-form.w-100(@submit.prevent="editFamily")
                div.border.rounded.py-3.my-3(v-for="(familyMember, index) in client.new_FamilyMember_Client_new_Client" :key="index")
                    b-container(fluid)
                        b-row(align-v="end").pb-3
                            b-col
                                b-form-group(label="Name: *").m-0
                                    b-form-input(v-model="familyMember.new_name" type="text" size="lg" style="font-weight: bold;" required)
                            b-col(md="auto")
                                b-button(@click="removeItem(index)" variant="danger" size="lg" :title="`Delete ${familyMember.new_name}`")
                                    b-icon(icon="trash") 
                        b-row(align-v="end")
                            b-col
                                b-form-group(label="Relationship to Main Client: *")
                                    b-form-input(v-model="familyMember.new_relationship" type="text" required)
                            b-col
                                b-form-group(label="Gender: *")
                                    b-form-select(v-model="familyMember.new_gender" required)
                                        b-form-select-option(value="")
                                        b-form-select-option(value="100000000") Male
                                        b-form-select-option(value="100000001") Female
                            b-col
                                b-form-group(label="Date of birth: *")
                                    b-form-input(v-model="familyMember.new_birthdate" type="date" required)
                            b-col
                                b-row(align-v="end")
                                    b-form-group.col.pr-0(label="Citizenship: *")
                                        b-form-select.bg-transparent(v-model="familyMember.new_citizenship" required)
                                            b-form-select-option(value="")
                                            b-form-select-option(value="100000000") Singapore
                                            b-form-select-option(value="100000001") Singapore PR
                                            b-form-select-option(value="100000002") Others
                                    b-form-group.col.pl-0(label="NRIC:")
                                        b-form-input.bg-transparent(type="text" v-model="familyMember.new_nric")                               
                            
                        b-row(align-v="end")
                            b-col
                                b-form-group(label="Employment Status: ")
                                    b-form-select(v-model="familyMember.new_employmentstatus")
                                        b-form-select-option(value="")
                                        b-form-select-option(value="100000000") Working
                                        b-form-select-option(value="100000001") Looking for work
                                        b-form-select-option(value="100000002") Not looking for work (homemaker/caregiver)
                                        b-form-select-option(value="100000003") Not looking for work (temporarily medically unfit)
                                        b-form-select-option(value="100000004") Not looking for work (permanently medically unfit)
                                        b-form-select-option(value="100000005") Not looking for work (retired)
                                        b-form-select-option(value="100000006") Not looking for work (others)
                            b-col
                                b-form-group(label="Employment Type:")
                                    div.d-flex.border.rounded
                                        b-form-select.bg-transparent.border-0(v-model="familyMember.new_employmenttype")
                                            b-form-select-option(value="")
                                            b-form-select-option(value="100000000") Full-time
                                            b-form-select-option(value="100000001") Part-time
                                            b-form-select-option(value="100000002") Hourly-rated
                                            b-form-select-option(value="100000003") Others
                                            b-form-select-option(value="100000004") N/A
                                        span.border(v-if="familyMember.new_employmenttype == 100000003")
                                        b-form-input.bg-transparent.border-0(v-if="familyMember.new_employmenttype == 100000003" type="text" v-model="familyMember.new_employmenttypeother" placeholder="Please specify")
                            b-col
                                b-form-group(label="Occupation/Income:")
                                    div.d-flex.border.rounded
                                        b-form-input.bg-transparent.border-0(v-model="familyMember.new_occupation" type="text" placeholder="Occupation")
                                        span.border
                                        b-form-input.bg-transparent.border-0(v-model.number="familyMember.new_income" type="number" min="0" placeholder="Income")
                            b-col
                                b-form-group(label="School/Level/Year (for school-going children):")
                                    div.d-flex.border.rounded
                                        b-form-input.bg-transparent.border-0(v-model="familyMember.new_school" type="text" placeholder="School")
                                        span.border
                                        b-form-select.bg-transparent.border-0.rounded-0(v-model="familyMember.new_schoollevel")
                                            b-form-select-option(:value="null")
                                            b-form-select-option(value="100000000") Primary
                                            b-form-select-option(value="100000001") Secondary
                                            b-form-select-option(value="100000002") Polytechnic
                                            b-form-select-option(value="100000003") University
                                        span.border
                                        b-form-input.bg-transparent.border-0(v-model.number="familyMember.new_schoolyear" type="number" min="0" placeholder="Year")

                        b-row(align-v="end")
                            b-col
                                b-form-group(label="Marital Status: ")
                                    div.d-flex.border.rounded
                                        b-form-select.bg-transparent.border-0(v-model="familyMember.new_maritalstatus")
                                            b-form-select-option(value="")
                                            b-form-select-option(value="100000000") Married
                                            b-form-select-option(value="100000001") Divorced
                                            b-form-select-option(value="100000002") Separated
                                            b-form-select-option(value="100000003") Widowed
                                            b-form-select-option(value="100000004") Single
                                            b-form-select-option(value="100000005") Others
                                        span.border(v-if="familyMember.new_maritalstatus == 100000005")
                                        b-form-input.bg-transparent.border-0(v-if="familyMember.new_maritalstatus == 100000005" type="text" v-model="familyMember.new_maritalstatusother" placeholder="Please specify")
                            b-col
                                b-form-group(label="Primary Spoken Language: ")
                                    div.d-flex.border.rounded
                                        b-form-select.bg-transparent.border-0(v-model="familyMember.new_language")
                                            b-form-select-option(value="")
                                            b-form-select-option(value="100000000") English
                                            b-form-select-option(value="100000001") Mandarin
                                            b-form-select-option(value="100000002") Malay
                                            b-form-select-option(value="100000003") Tamil
                                            b-form-select-option(value="100000004") Others
                                        span.border(v-if="familyMember.new_language == 100000004")
                                        b-form-input.bg-transparent.border-0(v-if="familyMember.new_language == 100000004" type="text" v-model="familyMember.new_languageother" placeholder="Please specify")
                            b-col
                                b-form-group(label="Race: ")
                                    div.d-flex.border.rounded
                                        b-form-select.bg-transparent.border-0(v-model="familyMember.new_race")
                                            b-form-select-option(value="")
                                            b-form-select-option(value="100000000") Chinese
                                            b-form-select-option(value="100000001") Malay
                                            b-form-select-option(value="100000002") Indian
                                            b-form-select-option(value="100000003") Others
                                        span.border(v-if="familyMember.new_race == 100000003")
                                        b-form-input.bg-transparent.border-0(v-if="familyMember.new_race == 100000003" type="text" v-model="familyMember.new_raceother" placeholder="Please specify")
                            b-col
                                b-form-group(label="Highest Education Level: ")
                                    div.d-flex.border.rounded
                                        b-form-select.bg-transparent.border-0(v-model="familyMember.new_education")
                                            b-form-select-option(value="")
                                            b-form-select-option(value="100000000") None
                                            b-form-select-option(value="100000001") PSLE
                                            b-form-select-option(value="100000002") N Level
                                            b-form-select-option(value="100000003") O Level
                                            b-form-select-option(value="100000004") NITEC
                                            b-form-select-option(value="100000005") HIGHER NITEC
                                            b-form-select-option(value="100000006") A Level
                                            b-form-select-option(value="100000007") Diploma
                                            b-form-select-option(value="100000008") Degree or higher
                                            b-form-select-option(value="100000009") Others
                                        span.border(v-if="familyMember.new_education == 100000009")
                                        b-form-input.bg-transparent.border-0(v-if="familyMember.new_education == 100000009" type="text" v-model="familyMember.new_educationother" placeholder="Please specify")
                
                b-button(@click="addItem()" variant="outline-secondary" size="lg" block) + Add Family Member      
                hr
                b-button(type="submit" :disabled="isSubmitting") {{ isSubmitting ? 'Saving...' : 'Save'}}
</template>

<script>
import dayjs from 'dayjs';
import Loader from '@/components/loader/Loading.vue';

export default {
    name: 'EditClientFamilyMemberComponent',
    components: {
        Loader
    },
    props: {
        clientId: {
            type: String,
            required: true
        },
        client: {
            type: Object,
            required: false
        }
    },
    computed: {
        /*client(){
            return this.$store.state.client;
        },*/
    },
    data(){
        return{
            isLoading: true,
            isSubmitting: false,
            itemToDeleteId: [],
            // use to clean up raw data
            tableColumn: {
                new_birthdate: null,
                new_citizenship: null,
                new_gender: null,
                new_income: null,
                new_name: null,
                new_occupation: null,
                new_relationship: null,
                new_school: null,
                new_schoollevel: null,
                new_schoolyear: null,
                new_nric: null,
                new_race: null,
                new_raceother: null,
                new_maritalstatus: null,
                new_maritalstatusother: null,
                new_education: null,
                new_educationother: null,
                new_language: null,
                new_languageother: null,
                new_employmentstatus: null,
                new_employmenttype: null,
                new_employmenttypeother: null,
            }
        }
    },
    async mounted() {
        if(!this.client) {
            let res = await this.getClient();
            this.isLoading = res ? false : true;
            return;
        }

        for(let item of this.client.new_FamilyMember_Client_new_Client) {
            //convert date to fit html date
            item.new_birthdate = item.new_birthdate ? dayjs(item.new_birthdate).format('YYYY-MM-DD') : null;
        }
        

        this.isLoading = false;
    },
    methods: {
        dayjs,
        async getClient() {
            return await this.$store.dispatch('getClient', this.clientId).then((res)=>{
                this.client = res;
                
                for(let item of this.client.new_FamilyMember_Client_new_Client) {
                    //convert date to fit html date
                    item.new_birthdate = item.new_birthdate ? dayjs(item.new_birthdate).format('YYYY-MM-DD') : null;
                }
                return true;
            }).catch((err)=>{
                window.alert(err);
                return false;
            })
        },
        async editFamily() {
            this.isSubmitting = true;
            let promiseItems = [];

            for(let item of this.client.new_FamilyMember_Client_new_Client) {
                // clean up payload
                for(let key in this.tableColumn) {
                    this.tableColumn[key] = item[key];
                }

                // post new item
                if(!item.new_familymemberid) {
                    let promiseItem = new Promise((resolve, reject) => {
                        try {
                            let result = this.$store.dispatch('addFamilyMember', {clientId:this.clientId, payload:this.tableColumn});
                            resolve(result);
                        } catch (err) {
                            reject(err);
                        }
                    });
                    promiseItems.push(promiseItem);
                }

                // patch existing item
                if(item.new_familymemberid) {
                    let promiseItem = new Promise((resolve, reject) => {
                        try {
                            let result = this.$store.dispatch('editFamilyMember', {familyMemberId:item.new_familymemberid, payload:this.tableColumn});
                            resolve(result);
                        } catch (err) {
                            reject(err);
                        }
                    });
                    promiseItems.push(promiseItem);
                }
            }

            // delete item
            for(let itemId of this.itemToDeleteId) {
                let promiseItem = new Promise((resolve, reject) => {
                    try {
                        let result = this.$store.dispatch('deleteFamilyMember', itemId);
                        resolve(result);
                    } catch (err) {
                        reject(err);
                    }
                });
                promiseItems.push(promiseItem);
            }

            Promise.all(promiseItems).then(()=>{
                this.isSubmitting = false;
                window.location.reload();
            }).catch((err)=>{
                window.alert(`Something when wrong when editing client's family members.\n${err}`);
            });
        },
        addItem() {
            this.client.new_FamilyMember_Client_new_Client.push({
                new_birthdate: null,
                new_citizenship: null,
                new_gender: null,
                new_income: null,
                new_name: null,
                new_occupation: null,
                new_relationship: null,
                new_school: null,
                new_schoollevel: null,
                new_schoolyear: null,
                new_nric: null,
                new_race: null,
                new_raceother: null,
                new_maritalstatus: null,
                new_maritalstatusother: null,
                new_education: null,
                new_educationother: null,
                new_language: null,
                new_languageother: null,
                new_employmentstatus: null,
                new_employmenttype: null,
                new_employmenttypeother: null,
            });
        },
        removeItem(index) {
            if (index < 0) { return false; }

            // remove from array
            let item = this.client.new_FamilyMember_Client_new_Client[index];

            // if it's an item from the db, temporary store id to delete when user click save
            if(item.new_familymemberid) {
                this.itemToDeleteId.push(item.new_familymemberid);
            }

            this.client.new_FamilyMember_Client_new_Client.splice(index, 1);
        }
    }
}
</script>

<style>
</style>